import { type UseQueryResult, useQuery } from 'react-query';
import {
  StockService,
  // eslint-disable-next-line camelcase
  type Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDto,
} from '../../services/wealthlane-finance-integration-services';
import { type ChartFilter } from '../../types/common';

const useGetStock = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  stockFilter: ChartFilter
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_FinanceIntegrationService_Dtos_StockDto_StockDto | undefined,
  unknown
> => {
  const stockApi = useQuery(['getStockData', stockFilter], async () => {
    const { fromDate, toDate } = stockFilter;
    return await handleRequest(
      StockService.getApiFinanceIntegrationApiAppStockStocks(fromDate, toDate)
    );
  });
  return stockApi;
};

export default useGetStock;
